import { get } from "lodash";

export const shouldShowCashSweepConditions = loan => Boolean(get(loan, "covenants.cashSweepConditions"));

export const shouldShowCashManagementCure = loan => Boolean(get(loan, "covenants.cashManagementCure"));

export const shouldShowCashSweepAccount = loan => Boolean(get(loan, "covenants.cashSweepAccount"));

export const shouldShowApplicationOfFunds = loan => Boolean(get(loan, "covenants.applicationOfFunds"));

export const shouldShowCashManagementMisc = loan => Boolean(get(loan, "covenants.cashManagementMisc"));
